module.exports = __webpack_public_path__ + "media/icons/nav-profile@3x-black-edc57edf.png";